import { createTheme, responsiveFontSizes } from "@mui/material/styles";

let themes = createTheme({
  palette: {
    action: {
      disabled: "#bdbdbd",
      disabledBackground: "rgba(209, 255, 26, 0.3)",
    },
    primary: {
      main: "#614075",
      hover: "rgba(70, 56, 160,1)",
    },
    secondary: {
      main: "#02001F",
      hover: "rgba(70, 56, 160,1)",
    },

    text: {
      main: "#212121",
      primary: "#212121",
      secondary: "#414141",
    },
    background: {
      main: "#000000",
      light: "rgba(106, 85, 234,0.6)",
    },
    textColors: {
      heading: "#000000",
      subheading: "#454545",
      light: "#757575",
      pbr: "rgba(224, 7, 125, 1)",
      secondary: "#E0077D",
      textPrimary: "#ffffff",
      textSecondary: "#1e1e1e",
      textLight: "#212121",
      textDark: "#e5e5e5",
    },
    slider: {
      trackColor: "purple",
      selectionColor: "purple",
    },
    mode: "dark",
  },
  typography: {
    fontFamily: "Poppins, Roboto, sans-serif",
    h1: {
      fontFamily: "Poppins",
      fontSize: "3rem",
    },
    h2: {
      fontFamily: "Poppins",
      fontSize: "2.4rem",
    },
    h3: {
      fontFamily: "Poppins",
      fontSize: "1.75rem",
      fontWeight: 600,
    },
    h4: {
      fontFamily: "Poppins",
      fontSize: "1.5rem",
      fontWeight: 600,
      letterSpacing: "0.02em",
    },
    h5: {
      fontFamily: "Poppins",
      fontSize: "1.0rem",
      fontWeight: 500,
    },
    h6: {
      fontFamily: "Poppins",
      fontSize: "0.75",
      fontWeight: 600,
    },
    subtitle1: {
      fontFamily: "Poppins",
      fontSize: "1.25rem",
      fontWeight: "bold",
    },
    body1: {
      fontFamily: "Poppins",
      fontSize: "1.125rem",
      fontWeight: 400,
      fontSize: 16,
      letterSpacing: "0.02em",
    },
    body2: {
      fontFamily: "Poppins",
      fontSize: "1rem",
    },
  },
  components: {
    MuiMenu: {
      styleOverrides: {
        root: {
          color: "",
        },
      },
    },
  },

  // breakpoints: {
  //   values: {
  //     xs: 0,
  //     sm: 600,
  //     md: 960,
  //     lg: 1280,
  //     xl: 1920,
  //   },
  // },
});

let theme = responsiveFontSizes(themes);
export default theme;
